import Vue from 'vue'
import Router from 'vue-router'

const login = () => import('../components/login.vue')
const home = () => import('../components/home.vue')
const news = () => import('../components/new.vue')
const news2 = () => import('../components/new2.vue')
const more = () => import('../components/more.vue')
const more2 = () => import('../components/more2.vue')
const admin = () => import('@/components/admin.vue')
const users = () => import('@/components/admin/users.vue')
const editnews = () => import('@/components/admin/editnews.vue')
const editnotices = () => import('@/components/admin/editnotices.vue')
const editpicture = () => import('@/components/admin/editpicture.vue')
const editpicture2 = () => import('@/components/admin/editpicture2.vue')
const editpicture3 = () => import('@/components/admin/editpicture3.vue')
const dictionary = () => import('@/components/admin/dictionary.vue')
const navigation = () => import('@/components/navigation.vue')
const workbench = () => import('@/components/workbench.vue')
const texttools = () => import('@/components/texttools.vue')
const chat = () => import('@/components/chat.vue')
const navigatList = () => import('@/components/navigat/list.vue')
const recommend = () => import('@/components/admin/recommend.vue')
const official = () => import('@/components/official.vue')
const diy = () => import('@/components/diy.vue')
const stock = () => import('@/components/stock.vue')
const stocktrades = () => import('@/components/admin/stocktrades.vue')
const stockquant = () => import('@/components/admin/stockquant.vue')

Vue.use(Router)

const rout = new Router(
  {
    linkActiveClass: 'nav-menus-active',
    transitionOnLoad: true,
    hashbang: false,
    history: true,
    mode: 'history',
    routes: [
      {path: '/', name: '/', component: official},
      {path: '/login', name: 'login', component: login},
      {path: '/home', name: 'home', component: home},
      {path: '/news', name: 'news', component: news},
      {path: '/news2', name: 'news2', component: news2},
      {path: '/more', name: 'more', component: more},
      {path: '/more2', name: 'more2', component: more2},
      {path: '/navigation', name: 'navigation', component: navigation},
      {path: '/workbench', name: 'workbench', component: workbench},
      {path: '/texttools', name: 'texttools', component: texttools},
      {path: '/chat', name: 'chat', component: chat},
      {path: '/diy', name: 'diy', component: diy},
      {path: '/stock', name: 'stock', component: stock},
      {path: '/official', name: 'official', component: official},
      {
        path: '/admin',
        name: 'admin',
        component: admin,
        redirect: 'users',
        children:
        [
          {path: '/editnews', name: 'editnews', component: editnews},
          {path: '/editnotices', name: 'editnotices', component: editnotices},
          {path: '/editpicture', name: 'editpicture', component: editpicture},
          {path: '/editpicture2', name: 'editpicture2', component: editpicture2},
          {path: '/editpicture3', name: 'editpicture3', component: editpicture3},
          {path: '/users', name: 'users', component: users},
          {path: '/dictionary', name: 'dictionary', component: dictionary},
          {path: '/navigatList', name: 'navigatList', component: navigatList},
          {path: '/recommend', name: 'recommend', component: recommend},
          {path: '/stocktrades', name: 'stocktrades', component: stocktrades},
          {path: '/stockquant', name: 'stockquant', component: stockquant}
        ]
      }
    ]
  }
)

rout.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/navigation' || to.path === '/texttools' || to.path === '/diy' || to.path === '/') return next()
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

rout.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
})

export default rout



// WEBPACK FOOTER //
// ./src/router/index.js